import { render, staticRenderFns } from "./CrmLeadDetailCommentForm.vue?vue&type=template&id=a8d64218&scoped=true&lang=pug&"
import script from "./CrmLeadDetailCommentForm.vue?vue&type=script&lang=js&"
export * from "./CrmLeadDetailCommentForm.vue?vue&type=script&lang=js&"
import style0 from "./CrmLeadDetailCommentForm.vue?vue&type=style&index=0&id=a8d64218&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d64218",
  null
  
)

export default component.exports